// InstitutionList.jsx
import React, { useState, useEffect } from "react";
import { InstitutionApi } from "../../../../api";
import { Loader } from "semantic-ui-react";
import { map, size } from "lodash";
import { useAuth } from "../../../../hooks";
import { InstitutionItem } from "../InstitutionItem";
import { useTranslation } from "react-i18next";
import "./InstitutionList.scss";

const institutionController = new InstitutionApi();

export function InstitutionList(props) {
  const { institutionActive, reload, onReload, onEdit } = props;
  const [institutions, setInstitutions] = useState(null);
  const { user, accessToken } = useAuth();
  const { t } = useTranslation("institutions");

  useEffect(() => {
    (async () => {
      try {
        setInstitutions(null);
        const response = await institutionController.getInstitutions(
          accessToken,
          user.user._id,
          institutionActive,
        );
        // Supongamos que la respuesta es { code, institutions: [...] }
        if (response.institutions && response.institutions.length > 0) {
          setInstitutions(response.institutions);
        } else {
          setInstitutions([]);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [institutionActive, user, reload, accessToken]);

  if (!institutions) {
    return <Loader active inline="centered" />;
  }
  if (size(institutions) === 0) {
    return t("item.noInstitutions");
  }

  return (
    <div className="institution-list-container">
      {map(institutions, (institution) => (
        <InstitutionItem
          key={institution._id}
          institution={institution}
          onReload={onReload}
          onEdit={onEdit} // <-- Pasamos callback para “Editar”
        />
      ))}
    </div>
  );
}
